import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import {
  liveMapPollingUiAtom,
  useFormats,
  useSystemParams,
} from "@ryde/shared";

import { LiveMapPollTooltipLinesStyled } from "./live-map.styled";
import { useLiveMapToolbarStats } from "./use-live-map-toolbar-stats";

export const useLiveMapMapPollTooltip = () => {
  const { t } = useTranslation();
  const { enableIncidents } = useSystemParams();
  const { formatDateTimeWithSecondsNormalized } = useFormats();
  const { mapRidesCount, mapDisplayedIncidentsCount } =
    useLiveMapToolbarStats();
  const { lastSynchroMapDate, mapPoolingCount = 0 } =
    useRecoilValue(liveMapPollingUiAtom);

  return useMemo(() => {
    if (!lastSynchroMapDate) {
      return t("rideMap.LIVE_MAP_MAP_POLL_STATUS_PENDING");
    }

    const lastTime = formatDateTimeWithSecondsNormalized(lastSynchroMapDate);
    const lines: string[] = [
      t("rideMap.LIVE_MAP_MAP_DISPLAYED_RIDES", { count: mapRidesCount }),
    ];

    if (enableIncidents && mapDisplayedIncidentsCount > 0) {
      lines.push(
        t("rideMap.LIVE_MAP_MAP_DISPLAYED_INCIDENTS", {
          count: mapDisplayedIncidentsCount,
        }),
      );
    }

    return (
      <LiveMapPollTooltipLinesStyled>
        {lines.map(line => (
          <span key={line}>{line}</span>
        ))}
        <span>
          {t("rideMap.LIVE_MAP_MAP_UPDATED_AT")} {lastTime}
        </span>
        <span>
          {t("rideMap.LIVE_MAP_DATA_LOADED_TIMES", { count: mapPoolingCount })}
        </span>
      </LiveMapPollTooltipLinesStyled>
    );
  }, [
    enableIncidents,
    formatDateTimeWithSecondsNormalized,
    lastSynchroMapDate,
    mapDisplayedIncidentsCount,
    mapPoolingCount,
    mapRidesCount,
    t,
  ]);
};
